var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as R from "ramda";
import { LISTS } from "./constants/types.mjs";
const parseOverviewStructureList = ({ agencyIds, fromCategory, space, type }) => (sdmxJson) => {
  return R.pipe(
    R.prop("data"),
    R.ifElse(
      R.always(type === "all"),
      R.values,
      R.pipe(R.prop(LISTS[type]), (list) => [list])
    ),
    R.reduce((acc, list) => {
      const parsedList = R.reduce(
        (acc2, artefact) => {
          const agencyId = artefact.agencyID;
          const code = artefact.id;
          const version = artefact.version;
          const isFinal = artefact.isFinal;
          const label = R.prop("name")(artefact);
          const sdmxId = `${agencyId}:${code}(${version})`;
          const id = `${space.id}:${type}:${sdmxId}`;
          return __spreadProps(__spreadValues({}, acc2), {
            [id]: {
              agencyId,
              code,
              version,
              type,
              isFinal,
              label,
              sdmxId,
              id,
              space
            }
          });
        },
        {},
        list
      );
      return R.mergeRight(acc, parsedList);
    }, {}),
    R.when(
      R.always(fromCategory && !R.isEmpty(agencyIds)),
      R.filter(R.pipe(R.prop("agencyId"), R.flip(R.includes)(agencyIds)))
    )
  )(sdmxJson);
};
export {
  parseOverviewStructureList
};
